import { IAssignDevicesState } from './devicesFormContext';
import { AssignDevicesActionTypes, TAssignDevicesAction } from './devicesFormActions';

export const devicesFormReducer = (state: IAssignDevicesState, action: TAssignDevicesAction): IAssignDevicesState => {
	switch (action.type) {
		case AssignDevicesActionTypes.SET_RESTAURANT_DEVICES:
			return {
				...state,
				restaurantDevices: action.payload.restaurantDevices,
			};
		case AssignDevicesActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case AssignDevicesActionTypes.TOGGLE_SHOW_FREE_DEVICES:
			return {
				...state,
				showFreeDevices: !state.showFreeDevices,
				currentPage: 1,
			};
		case AssignDevicesActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case AssignDevicesActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case AssignDevicesActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case AssignDevicesActionTypes.SET_DATA_FOR_ASSIGN:
			return {
				...state,
				dataForAssign: action.payload.dataForAssign,
			};
		case AssignDevicesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
